/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_DemandInputs */

const en_nav_demand = /** @type {(inputs: Nav_DemandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demand`)
};

/**
* | output |
* | --- |
* | "Demand" |
*
* @param {Nav_DemandInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_demand = /** @type {((inputs?: Nav_DemandInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_DemandInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_demand(inputs)
});